var exports = {
  "k": "xe564cbfb--14456e--container",
};

module.exports = exports;
